import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState } from 'react';
import classNames from 'utils/classNames';

const ConfirmOkOnly = ({
  open,
  setOpen,
  titleText,
  okText = 'Ok',
  children,
  maxWidth = 'max-w-md',
  onOkClick = null,
}) => {
  const onClose = () => {
    setOpen(false);
    if (onOkClick) onOkClick();
  };

  return (
    <>
      <Transition appear show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40" onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={classNames(
                    'w-full transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all',
                    maxWidth
                  )}
                >
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    {titleText}
                  </Dialog.Title>
                  <div className="mt-2 text-center">{children}</div>
                  <div className="mt-4 text-center">
                    <button
                      type="button"
                      className="px-8 py-2 bg-custom-green text-white rounded-full tracking-2 font-bold"
                      onClick={onClose}
                    >
                      {okText}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
export default ConfirmOkOnly;
